import { Api } from "./Api";

export let _token = "";
export let _onUnauthorized: (() => void) | null = null;

// Use this when you want to talk to the backend api.
// We used to do axios.defaults.headers to set the auth token authomatically for all requests.
// However, when we do this, a bug currently prevents us to unset the token in any way.
// This prevents us from using AWS S3 wich return 400 because Authorization is always set.
// https://github.com/axios/axios/issues/385

export const api = (): Api => {
    return Api.getInstance();
};


export const setToken = (token: string): void => {
    _token = token;
};

export const setOnUnauthorized = (callback: () => void): void => {
    _onUnauthorized = callback;
};
